<template>
  <div class="writer">
    <span class="writerSpan">{{ shownText }}{{ blinkingcurser }}</span>
  </div>
</template>

<script>
export default {
  props: {
    // 传递需要显示的文本内容
    text: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      index: 0, //用于跟踪当前正在显示的文本字符的索引
      textIndex: 0, //用于跟踪当前正在显示的文本数组的索引
      shownText: "", //存储当前已经显示到界面上的文本
      speed: 80, // 控制文本显示速度（毫秒）
      curser: "|", //光标字符
      blinkingcurser: "", //用于在模板中显示或隐藏光标的变量
      curserBlinkingSpeed: 600, // 控制光标闪烁速度（毫秒）
      erase: false, //布尔值，用于控制是否开始擦除已显示的文本
      waiter: 0, //用于控制擦除文本的速度，每次减少到0时开始擦除
      defaultwaiter: 10, // 定义waiter的初始值，基于speed
    };
  },
  computed: {},
  methods: {
    typeIt() {
      if (this.textIndex < this.text.length) {
        if (
          this.text[this.textIndex].length > 0 &&
          this.shownText != this.text[this.textIndex] &&
          !this.erase
        ) {
          this.waiter = this.defaultwaiter;
          this.shownText = this.text[this.textIndex].substr(0, this.index);
          this.index++;
        } else if (this.shownText.length == 0) {
          this.erase = false;
          this.textIndex++;
        } else if (this.shownText == this.text[this.textIndex] || this.erase) {
          if (this.waiter == 0) {
            this.erase = true;
            this.shownText = this.text[this.textIndex].substr(0, this.index);
            this.index--;
          } else {
            this.waiter--;
          }
        }
      } else {
        this.textIndex = 0;
      }
    },
    blinking() {
      if (this.blinkingcurser != "") {
        this.blinkingcurser = "";
      } else {
        this.blinkingcurser = this.curser;
      }
    },
  },
  mounted() {
    setInterval(this.typeIt, this.speed);
    setInterval(this.blinking, this.curserBlinkingSpeed);
  },
};
</script>
<style lang="less" scoped>
.writer{
  min-height: 54px;
}
.writerSpan{
  font-size: 2.5rem;
  display: inline-block;
  font-weight: 600;
  min-height: 54px;
  height: 54px;
  color: var(--theme-writter-color);
}
</style>


// WEBPACK FOOTER //
// src/views/typeWriter.vue